import interLatin from "@/shared/assets/fonts/inter-latin.woff2";
import interLatinExt from "@/shared/assets/fonts/inter-latin-ext.woff2";

// Inter registered via the FontFace API, not an @font-face rule: Bun's CSS bundler inlines every url()
// as a base64 data URI, bloating the render-blocking CSS and defeating the unicode-range split. A JS
// import emits each woff2 as a separate hashed, cacheable file; the browser still honours unicodeRange.
const descriptors: FontFaceDescriptors = {
  weight: "100 900",
  style: "normal",
  display: "swap",
};

const faces = [
  new FontFace("Inter", `url(${interLatin})`, {
    ...descriptors,
    unicodeRange:
      "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
  }),
  new FontFace("Inter", `url(${interLatinExt})`, {
    ...descriptors,
    unicodeRange:
      "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF",
  }),
];

for (const face of faces) {
  document.fonts.add(face);
}
